import React from "react";
import _ from "lodash";
import { Box, Input, Separator, Text } from "@showitinc/showit-wc";
import ViewPanel from "../ViewPanel";
import ButtonBar from "../SetupButtonBar";


function canProceed(blogUrl) {
  return (
    blogUrl !== undefined &&
    blogUrl.length > 10 &&
    (blogUrl.indexOf("http://") === 0 || blogUrl.indexOf("https://") === 0)
  );
}

function CurrentBlogDomain({ blogSetup: { setupData }, actions }) {
  const { blog_url: blogUrl } = setupData;

  const proceed = () => {
    let url = blogUrl;
    try {
      if (!url.includes("http://") && !url.includes("https://")) {
        url = `http://${url}`;
      }

      url = url.replace("www.", "").toLowerCase();
    } catch (e) {
      console.log(e);
    }
    actions.goToNextStep({ blog_url: url });
  };

  const btnAction = canProceed(blogUrl) ? proceed : undefined;

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Current Blog Domain
            </Text>
            <Separator />
            <Text>
              Ready to migrate your blog to Showit? We'll first ask you for some basic information
              about your current blog so we can determine the best way to move everything over.
            </Text>
            <Box my="3">
              <Text>
                Enter the URL for your current site. <br />
                <span className="muted">Please include http:// or https:// at the beginning.</span>
              </Text>
              <Input
                type="text"
                name="blog_url"
                placeholder="https://example.com"
                value={setupData.blog_url}
                label="Domain Name"
                onSIChange={(e) => actions.updateSetup({ blog_url: e.target.value })}
              />
            </Box>
          </>
        ),
        actions: (
          <ButtonBar
            onForward={btnAction}
            onBack={actions.goToPrevStep}
            allowForward={btnAction !== undefined}
            allowBack
          />
        ),
      }}
    </ViewPanel>
  );
}

export default CurrentBlogDomain;
